import { LocalStorageService } from '../services/LocalStorageService';
import { ViewManagementService } from '../services/ViewManagementService';
import { UnifiedQueryService } from '../services/UnifiedQueryService';
import { UserSelectionService } from '../services/UserSelectionService';
import { ViewUserSelectionManager } from '../services/ViewUserSelectionManager';

/**
 * 服务工厂类
 * 负责创建和管理服务实例，简化依赖注入
 */
export class ServiceFactory {
  constructor() {
    this._services = new Map();
  }

  /**
   * 获取或创建存储服务
   * @returns {LocalStorageService} 存储服务实例
   */
  getStorageService() {
    if (!this._services.has('storage')) {
      this._services.set('storage', new LocalStorageService());
    }
    return this._services.get('storage');
  }

  /**
   * 获取或创建视图管理服务
   * @returns {ViewManagementService} 视图管理服务实例
   */
  getViewManagementService() {
    if (!this._services.has('viewManagement')) {
      const storageService = this.getStorageService();
      this._services.set('viewManagement', new ViewManagementService(storageService));
    }
    return this._services.get('viewManagement');
  }

  /**
   * 获取或创建统一查询服务
   * @param {Object} erpDatabaseStore - ERP数据库存储
   * @returns {UnifiedQueryService} 统一查询服务实例
   */
  getUnifiedQueryService(erpDatabaseStore) {
    const key = `unifiedQuery_${erpDatabaseStore.constructor.name}`;
    if (!this._services.has(key)) {
      const viewManagementService = this.getViewManagementService();
      this._services.set(key, new UnifiedQueryService(erpDatabaseStore, viewManagementService));
    }
    return this._services.get(key);
  }

  /**
   * 获取或创建用户选择服务
   * @returns {UserSelectionService} 用户选择服务实例
   */
  getUserSelectionService() {
    if (!this._services.has('userSelection')) {
      const storageService = this.getStorageService();
      this._services.set('userSelection', new UserSelectionService(storageService));
    }
    return this._services.get('userSelection');
  }

  /**
   * 获取或创建视图-用户选择管理服务
   * @returns {ViewUserSelectionManager} 视图-用户选择管理服务实例
   */
  getViewUserSelectionManager() {
    if (!this._services.has('viewUserSelectionManager')) {
      const storageService = this.getStorageService();
      this._services.set('viewUserSelectionManager', new ViewUserSelectionManager(storageService));
    }
    return this._services.get('viewUserSelectionManager');
  }

  /**
   * 清理所有服务实例
   */
  clear() {
    this._services.clear();
  }
}

// 创建全局工厂实例
export const serviceFactory = new ServiceFactory();
